import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import Autocomplete from 'react-autocomplete';
import { v4 } from 'uuid';
import { Form, Text } from 'react-form';
import Modal from 'react-modal';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';

import { isEmptyObj } from '../helpers/Helpers';

import RecentSearch from './search-service/RecentSearch';
// import SocialLinks from './search-service/SocialLinks';

import {
  fetchSearchService,
  clearSearchService,
} from '../actions/SearchServiceAction';
import { fetchSearchLocation } from '../actions/SearchLocationAction';
import { fetchServices, getId, getName } from '../actions/ServicesAction';
import { saveSearchField } from '../actions/SearchFieldAction';
import { fetchTicketInfo, clearTicketInfo } from '../actions/TicketAction';

import iconChangeDirectionNX from '../assets/images/change-direction-blue-icon-vertical.svg';
import iconChangeDirectionBusEireann from '../assets/images/bus-eireann/change-direction-btn.svg';
import iconChangeDirectionDublinExpress from '../assets/images/dublin-express/change-direction-btn.svg';
import iconChangeDirectionMegabus from '../assets/images/dublin-express/change-direction-btn.svg';
import iconChangeDirectionWCCE from '../assets/images/wcce/change-direction.svg';
import iconChangeDirectionNXbus from '../assets/images/nxbus/change-direction.svg';
import iconChangeDirectionCitylink from '../assets/images/citylink/change-direction.svg';
import iconHelpNX from '../assets/images/help-icon.svg';
import iconHelpBusEireann from '../assets/images/bus-eireann/help-icon.svg';
import iconHelpMegabus from '../assets/images/megabus/help-icon.svg';

import iconTwitterMegabus from '../assets/images/megabus/twitter.svg';
import iconFacebookMegabus from '../assets/images/megabus/facebook.svg';
import iconInstagramMegabus from '../assets/images/megabus/instagram.svg';

import iconTwitterCitylink from '../assets/images/citylink/twitter.svg';
import iconFacebookCitylink from '../assets/images/citylink/facebook.svg';
import iconInstagramCitylink from '../assets/images/citylink/instagram.svg';

import IconClose from '../assets/images/ic-close.svg';
import DublinIconClose from '../assets/images/dublin-express/ic-close.svg';
import MegaBusIconClose from '../assets/images/megabus/ic-close.svg';

import iconClearInput from '../assets/images/clear-search-icon.svg';

import iconLocation from '../assets/images/route-finder/location-icon.svg';

import adsHolder from '../assets/images/NXR_proposal_V3.png';

import validator from 'validator';
import md2 from 'js-md2';
import { Base64 } from 'js-base64';

import { THEME } from '../configs/global';

Modal.setAppElement('#root');

const getCloseIcon = (name) => {
  switch (name) {
    case 'NX':
      return IconClose;
    case 'Bus-Eireann':
      return IconClose;
    case 'Dublin-Express':
      return DublinIconClose;
    case 'Megabus':
      return MegaBusIconClose;
    case 'NX-Bus':
      return MegaBusIconClose;
    default:
      return IconClose;
  }
};

const getChangeDirectionIcon = (name) => {
  switch (name) {
    case 'NX':
      return iconChangeDirectionNX;
    case 'Bus-Eireann':
      return iconChangeDirectionBusEireann;
    case 'Dublin-Express':
      return iconChangeDirectionDublinExpress;
    case 'Megabus':
      return iconChangeDirectionMegabus;
    case 'WCCE':
        return iconChangeDirectionWCCE;  
    case 'NX-Bus':
      return iconChangeDirectionNXbus;
    case 'Citylink':
      return iconChangeDirectionCitylink;
    default:
      return iconChangeDirectionNX;
  }
};

const getHelpIcon = (name) => {
  switch (name) {
    case 'NX':
      return iconHelpNX;
    case 'Bus-Eireann':
      return iconHelpBusEireann;
    case 'Megabus':
      return iconHelpMegabus;
    case 'NX-Bus':
      return iconHelpMegabus;

    default:
      return iconHelpNX;
  }
};

const isShowingAds = (name) => {
  switch (name) {
    case 'NX':
      return true;
    default:
      return false;
  }
};

const isShowingSocials = (name) => {
  switch (name) {
    case 'Megabus':
      return true;
    case 'Citylink':
      return true;
    default:
      return false;
  }
};

const getContentText = (name, tabIndex) => {
  switch (name) {
    case 'Dublin-Express':
      return {
        'coach-search-subtitle':
          'Coach Tracker allows you to search for your service, tracking your coach in real-time with live departure and arrival times',
      };
    case 'Megabus':
      switch (tabIndex) {
        case 0:
          return {
            'coach-search-subtitle':
              THEME.PAGES.SEARCH.TITLE,
          };
        case 1:
          return { 'coach-search-subtitle': THEME.PAGES.SEARCH.TITLE };

        default:
          return {
            'coach-search-subtitle':
              THEME.PAGES.SEARCH.TITLE,
          };
      }
    case 'NX-Bus':
      switch (tabIndex) {
        case 0:
          return {
            'coach-search-subtitle':
              THEME.PAGES.SEARCH.TITLE,
          };
        case 1:
          return { 'coach-search-subtitle': THEME.PAGES.SEARCH.TITLE };

        default:
          return {
            'coach-search-subtitle':
              THEME.PAGES.SEARCH.TITLE,
          };
      }
      case 'NX':
        return {
          'coach-search-subtitle':
            'Coach Tracker allows you to search for your service, tracking your coach in real-time with live departure and arrival times',
        };
      default:
        return {
          'coach-search-subtitle':
            THEME.PAGES.SEARCH.TITLE,
        };
  }
};

const getSearchTabsText = (name, tabIndex) => {
  switch (name) {
    case 'NX-Bus':
      switch (tabIndex) {
        case 0:
          return {
            short: 'Location',
            long: 'Location Search',
          };
        case 1:
          return { short: 'Bus', long: 'Bus Number' };
        default:
          return null;
      }
    default:
      switch (tabIndex) {
        case 0:
          return {
            short: 'Location',
            long: 'Location Search',
          };
        case 1:
          return { short: 'Service', long: 'Service Number' };
        default:
          return null;
      }
  }
};

const stylesModal = {
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, .4)',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    width: '390px',
    maxWidth: '390px',
    maxHeight: '579px',
    minHeight: '579px',
    height: '60%',
    padding: '26px 30px',
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    border: '1px solid #B6BECC',
    borderRadius: 10,
    boxShadow: '0 0 8px 0 rgba(52,63,82,0.1)',
  },
};

const menuStyle = {
  background: 'transparent',
  left: 0,
  top: 55,
  position: 'absolute',
  maxHeight: 250,
  overflowY: 'auto',
  zIndex: 5,
};

const wrapperStyle = {
  width: '100%',
  position: 'relative',
};

const initStationObj = {
  name: '',
  id: null,
  internal_stop_ids: []
};

const initStationObjSrv = {
  name: '',
  id: null,
  route_id: null
};

const mapStateToProps = (state) => ({
  stations: state.searchService,
  userLocation: state.searchLocation,
  services: state.services,
  searchField: state.searchField,
  isMobile: state.mobileScreen.open,
  ticket: state.ticket,
});

class SearchService extends Component {
  state = {
    stationFrom: initStationObj,
    stationTo: initStationObj,
    stationFromService: initStationObjSrv,
    locationFrom: false,
    locationTo: false,
    initial: true,
    isShowValidationMsgs: false,
    validate: JSON.parse(localStorage.getItem('ticketNumber')) ? true : false,
    validateEmail: JSON.parse(localStorage.getItem('emailAddress'))
      ? true
      : false,
    validateTicket: null,
    isInfoModalOpen: false,
    emailAddress: JSON.parse(localStorage.getItem('emailAddress'))
      ? JSON.parse(localStorage.getItem('emailAddress'))
      : '',
    ticketSearch: JSON.parse(localStorage.getItem('ticketSearch'))
      ? JSON.parse(localStorage.getItem('ticketSearch'))
      : '',
    tabIndex: 0,
  };

  componentDidMount() {
    if (!localStorage.getItem('ticketSearch'))
      localStorage.setItem('emailAddress', JSON.stringify(null));
    this.setState({
      validTicket: true,
      clearTicket: false,
      showAds: isShowingAds(THEME.NAME),
      showTabs: THEME.SHOW_TABS,
      showSocials: isShowingSocials(THEME.NAME),
      showTicketLookup: THEME.TICKET_SEARCH,
      ...this.props.searchField,
      validate: !!localStorage.getItem('ticketSearch'),
    });
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
  }

  componentDidUpdate(prevProps) {
    const { location, services } = this.props;
    if (
      !isEmptyObj(this.props.ticket) &&
      !isEmptyObj(prevProps.ticket) &&
      (
        prevProps.location.pathname !== location.pathname)
    ) {
      if (
        !this.props.ticket.outboundServicesLegCount &&
        !this.props.ticket.inboundServicesLegCount
      ) {
        localStorage.setItem('ticketSearch', JSON.stringify(null));
        localStorage.setItem('emailAddress', JSON.stringify(null));

        this.setState({
          validTicket: false,
          ticketSearch: '',
          emailAddress: '',
        });
      } else {
        localStorage.setItem(
          'ticketSearch',
          JSON.stringify(this.props.ticket.ticketDetails.ticketNumber)
        );
        this.props.ticket.ticketDetails.ticketNumber
          ? localStorage.setItem(
              'emailAddress',
              JSON.stringify(this.state.emailAddress)
            )
          : localStorage.setItem('', JSON.stringify(null));

        this.setState({
          validTicket: true,
        });
      }
    }

    if (
      prevProps.location.pathname !== location.pathname &&
      location.pathname === '/'
    ) {
      this.clearSearch();
      if (
        !isEmptyObj(this.props.ticket) &&
        !this.props.ticket.outboundServicesLegCount &&
        !this.props.ticket.inboundServicesLegCount
      ) {
        this.setState({
          ticketNum: 'cleared',
          emailAddress: '',
        });
      }
    }

    if (this.props.isClearSearch) {
      this.clearSearch();
      this.props.clearSearch(false);
    }
    if (
      this.state.initial &&
      Object.keys(services).length > 1 &&
      location.pathname !== '/'
    ) {
      this.setState({
        stationFrom: {
          name: services.stops[0].metadata.name
            ? services.stops[0].metadata.name
            : getName(services, 0),
          internal_stop_ids: services.stops[0].metadata.internal_id
            ? [services.stops[0].metadata.internal_id]
            : getId(services, 0),
        },
        stationTo: {
          name: services.to_stops_metadata
            ? services.to_stops_metadata[0].name
            : getName(services, 1),
          internal_stop_ids: services.to_stops_metadata
            ? services.to_stops_metadata[0].internal_id
            : getId(services, 1),
        },
        stationFromService: {
          route_id: this.state.stationFromService.route_id
            ? this.state.stationFromService.route_id
            : services.routes ? services.routes[0].metadata.route_id : null,
          id: this.state.stationFromService.id
            ? this.state.stationFromService.id
            : services.routes ? services.routes[0].metadata.route_id : null,
          type: 'service',
        },
        tabIndex: services.routes ? 1 : 0,
        initial: false,
      });

      /*this.props.saveSearchField({
        stationFrom: {
          name: getName(services, 0),
          id: getId(services.id, 0),
        },
        stationTo: {
          name: getName(services, 1),
          id: getId(services, 1),
        },
      });*/
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions = () => {
    if (document.getElementsByClassName('coach-search-tabs')[0]) {
      this.setState({
        searchTabWidth: document.getElementsByClassName('coach-search-tabs')[0]
          .offsetWidth,
      });
    }
  };

  clearSearch = () => {
    this.setState({
      stationFrom: {
        name: '',
        internal_stop_ids: []
      },
      stationTo: {
        name: '',
        internal_stop_ids: []
      },
      stationFromService: {
        route_id: '',
      },
      isShowValidationMsgs: false,
    });
  };

  swapDirection = (e) => {
    const { stationFrom, stationTo } = this.state;

    if (stationFrom.name && stationTo.name) {
      this.setState({
        stationFrom: {
          ...stationTo,
        },
        stationTo: {
          ...stationFrom,
        },
      });
    }
  };

  fetchLocation = (isFrom) => {
    const { fetchSearchLocation } = this.props;

    navigator.geolocation.getCurrentPosition(
      function (position) {
        var latitude = position.coords.latitude.toFixed(6);
        var longitude = position.coords.longitude.toFixed(6);
        fetchSearchLocation(latitude, longitude);
      },
      function error(err) {
        alert(`ERROR: ${err.message}`);
      }
    );

    isFrom
      ? this.setState({ locationFrom: true })
      : this.setState({ locationTo: true });
  };

  fetchStations = (value, isFrom, service) => {
    if (
      (value.length && !/^([A-Za-z0-9'() :,_-]+)$/.test(value)) ||
      value.length > 60
    )
      return false;

    const { fetchSearchService } = this.props;

    const { stationFrom, stationTo } = this.state;

    if (value.length > 1) {
      if (isFrom && stationTo.internal_stop_ids) {
        fetchSearchService(value, stationTo.internal_stop_ids, service);
      } else if (!isFrom && stationFrom.internal_stop_ids) {
        fetchSearchService(value, stationFrom.internal_stop_ids, service);
      } else {
        fetchSearchService(value, null, service);
      }
    }

    service
      ? this.setState((prevState) => ({
          stationFromService: {
            ...prevState.stationFromService,
            route_id: value,
          },
        }))
      : isFrom
      ? this.setState((prevState) => ({
          stationFrom: {
            ...prevState.stationFrom,
            name: value,
          },
        }))
      : this.setState((prevState) => ({
          stationTo: {
            ...prevState.stationTo,
            name: value,
          },
        }));
  };

  showStations = (stationFrom, stationTo) => (e) => {
    e.preventDefault();

    if (stationFrom.type && stationFrom.type === 'service')
      this.props.fetchServices(
        stationFrom.route_id,
        0,
        'service',
        this.showValidationMsgs,
        this.props.history
      );
    else if (!stationTo.internal_stop_ids || !stationTo.internal_stop_ids.length)
      this.props.fetchServices(
        stationFrom.internal_stop_ids[0],
        0,
        'stop',
        this.showValidationMsgs,
        this.props.history
      );
    else
      this.props.fetchServices(
        stationFrom.internal_stop_ids[0],
        stationTo.internal_stop_ids[0],
        'between',
        this.showValidationMsgs,
        this.props.history
      );
  };

  highlightEnteredText = (item, search, theme) => {
    let text = item.name ? item.name : item.route_id;
    if (!text || !search) return false;
    let type = item.internal_stop_ids ? 'stop' : 'service';
    let pos = text.toLowerCase().indexOf(search.toLowerCase());
    if (pos === -1) pos = text.length;
    if (theme === 'Megabus' && text) {
      if (type === 'stop') {
        let arr = [
          text.substring(0, text.indexOf(':') + 1),
          text.substring(text.indexOf(':') + 1),
        ];
        if (text.indexOf(':') !== -1) {
          if (search) {
            if (pos >= 0) {
              return (
                <div>
                  <span className="bold">
                    {arr[0].substring(0, pos)}
                    <span className="highlight">
                      {arr[0].substring(pos, pos + search.length)}
                    </span>
                    {arr[0].substring(pos + search.length)}
                  </span>
                  {arr[1].substring(0, pos - arr[0].length)}
                  <span className="highlight">
                    {arr[1].substring(
                      pos - arr[0].length,
                      pos - arr[0].length + search.length
                    )}
                  </span>
                  {arr[1].substring(pos - arr[0].length + search.length)}
                </div>
              );
            }
          }
          return (
            <div>
              <span className="bold">{arr[0]}</span>
              {arr[1]}
            </div>
          );
        }
      } else if (type === 'service') {
        let posDeparture = null;
        let posArrival = null;
        if (item.departure_location_name) {
          posDeparture = item.departure_location_name
            .toLowerCase()
            .indexOf(search.toLowerCase());
          if (posDeparture === -1)
            posDeparture = item.departure_location_name.length;
        }
        if (item.arrival_location_name) {
          posArrival = item.arrival_location_name
            .toLowerCase()
            .indexOf(search.toLowerCase());
          if (posArrival === -1) posArrival = item.arrival_location_name.length;
        }

        if (pos >= 0) {
          return (
            <div>
              <span className="service">
                {text.substring(0, pos)}
                <span className="highlight">
                  {text.substring(pos, pos + search.length)}
                </span>
                {text.substring(pos + search.length)}
              </span>
              {item.departure_location_name && (
                <span>
                  {item.departure_location_name.substring(0, posDeparture)}
                  <span className="highlight">
                    {item.departure_location_name.substring(
                      posDeparture,
                      posDeparture + search.length
                    )}
                  </span>
                  {item.departure_location_name.substring(
                    posDeparture + search.length
                  )}
                  <span className="to">&lt; &gt;</span>
                  {item.arrival_location_name.substring(0, posArrival)}
                  <span className="highlight">
                    {item.arrival_location_name.substring(
                      posArrival,
                      posArrival + search.length
                    )}
                  </span>
                  {item.arrival_location_name.substring(
                    posArrival + search.length
                  )}
                </span>
              )}
            </div>
          );
        }
      }
    }
    if (text && search) {
      if (pos >= 0) {
        return (
          <div>
            {text.substring(0, pos)}
            <span>{text.substring(pos, pos + search.length)}</span>
            {text.substring(pos + search.length)}
          </div>
        );
      }
      return text;
    }
    return text;
  };

  showValidationMsgs = (showMsgs) => {
    this.setState({
      isShowValidationMsgs: showMsgs,
    });
  };

  recentSearch = (obj) => (e) => {
    this.setState({
      stationFromService: {
        route_id: obj.request[0].service ? obj.request[0].service : null,
        id: obj.request[0].service ? obj.request[0].service : null,
        type: 'service',
      },
      tabIndex: obj.request[0].service ? 1 : 0,
      stationFrom: {
        name: getName(obj, 0),
        id: getId(obj, 0),
      },
      stationTo: {
        name: getName(obj, 1),
        id: getId(obj, 1),
      },
      isShowValidationMsgs: false,
    });

    if (obj.request[0].service)
      this.props.history.push(`/view/service/${obj.request[0].service}`);
    else if (!obj.request[1].stopId)
      this.props.history.push(`/view/stop/${getId(obj, 0)}`);
    else
      this.props.history.push(
        `/view/between/${getId(obj, 0)}/${getId(obj, 1)}`
      );
  };

  handleTicketForm = (
    theme,
    { submittedValues: { ticketNumber, emailAddress } }
  ) => {
    localStorage.setItem(
      'emailAddress',
      JSON.stringify(this.state.emailAddress)
    );
    let emailHash = null;
    if (theme === 'Megabus') {
      emailHash = Base64.encode(emailAddress.toLowerCase()).replace(/=/g,'');
    } else {
      emailHash = md2(emailAddress.toLowerCase());
    }

    this.props.fetchTicketInfo(ticketNumber, emailHash, () =>
      this.props.history.push(`/ticket/${emailHash}/${ticketNumber}`)
    );
  };

  validateTicket(value) {
    if (
      (value.length && !/^([A-Za-z0-9]+)$/.test(value)) ||
      value.length > 20
    ) {
      value = value.replace(/[^A-Za-z0-9]+/g, '').substring(0, 20);
      this.setState({ validateTicket: value });
    }
  }

  validate = (value) => {
    if (value && value.length > 3 && value.length <= 20) {
      this.setState({
        validate: true,
      });
    } else {
      this.setState({
        validate: false,
      });
    }
  };

  validateEmail = (value) => {
    if (value && validator.isEmail(value)) {
      this.setState({
        validateEmail: true,
      });
    } else {
      this.setState({
        validateEmail: false,
      });
    }
  };

  toggleInfoModal = (e) => {
    this.setState({
      isInfoModalOpen: !this.state.isInfoModalOpen,
    });
  };

  closeModal = (e) =>
    this.setState({
      isInfoModalOpen: false,
    });

  closeAd = (e) =>
    this.setState({
      showAds: false,
    });

  clearInput = (name) => (e) => {
    if (name === 'ticketNumber') {
      this.setState({ ticketSearch: '', clearTicket: true, validate: false });
      localStorage.setItem('ticketSearch', JSON.stringify(null));
    } else if (name === 'emailAddress') {
      localStorage.setItem('emailAddress', JSON.stringify(null));
      this.setState({ emailAddress: '', validateEmail: false });
    } else
      this.setState({
        [name]: initStationObj,
      });
  };

  renderLocationFormAutoComplete = () => {
    const { stationFrom } = this.state;
    const { stations, clearSearchService, isMobile } = this.props;

    let currentFrom = stationFrom.name;
    
    return (
      <Autocomplete
        items={!!stations.length && stations[0].name && currentFrom && currentFrom.length > 2 ? stations : []}
        getItemValue={(item) => item.name}
        renderItem={(item, isHighlighted) => (
          <div
            key={item.internal_stop_ids ? item.internal_stop_ids.join('') : ''}
            className={
              isHighlighted
                ? 'autocomplete autocomplete--highlighted'
                : 'autocomplete'
            }
          >
            {this.highlightEnteredText(item, currentFrom, THEME.NAME)}
          </div>
        )}
        value={stationFrom && stationFrom.name}
        onChange={(e) => {
          this.setState({
            stationFrom: {
              name: stationFrom.name
            }
          })
          currentFrom = e.target.value;
          this.fetchStations(e.target.value, true, false);
        }}
        onSelect={(name, obj) => {
          this.setState({
            stationFrom: obj,
          });
          clearSearchService(true);
        }}
        inputProps={{ placeholder: 'From',
                      maxLength: '60',
                      onFocus: (e) => {
                        currentFrom = e.target.value;
                        this.fetchStations(e.target.value, true, false);
                      }
                    }}
        wrapperStyle={isMobile ? wrapperStyle : { position: 'relative' }}
        menuStyle={isMobile ? { ...menuStyle, maxHeight: 200 } : menuStyle}
      />
    );
  };

  renderLocationToAutoComplete = (THEME) => {
    const { stationTo } = this.state;
    const { stations, clearSearchService, isMobile } = this.props;

    let currentTo = stationTo.name;

    return (
      <Autocomplete
        items={!!stations.length && stations[0].name && currentTo && currentTo.length > 2 ? stations : []}
        getItemValue={(item) => item.name}
        renderItem={(item, isHighlighted) => (
          <div
            key={item.internal_stop_ids ? item.internal_stop_ids.join('') : ''}
            className={
              isHighlighted
                ? 'autocomplete autocomplete--highlighted'
                : 'autocomplete'
            }
          >
            {this.highlightEnteredText(item, currentTo, THEME.NAME)}
          </div>
        )}
        value={stationTo && stationTo.name}
        onChange={(e) => {
          currentTo = e.target.value;
          this.fetchStations(e.target.value, false, false);
        }}
        onSelect={(name, obj) => {
          this.setState({
            stationTo: obj,
          });
          clearSearchService(true);
        }}
        inputProps={{ placeholder: `${THEME.NAME === 'Megabus' || THEME.NAME === 'NX-Bus' ? 'To (optional)' : 'To'}`, 
                      maxLength: '60',
                      onFocus: (e) => {
                        currentTo = e.target.value;
                        this.fetchStations(e.target.value, false, false);
                      }
        }}
        wrapperStyle={isMobile ? wrapperStyle : { position: 'relative' }}
        menuStyle={isMobile ? { ...menuStyle, maxHeight: 200 } : menuStyle}
      />
    );
  };

  renderLocationSearchForm = () => {
    const { stationFrom, stationTo } = this.state;
    let currentFrom = stationFrom.name;
    let currentTo = stationTo.name;
    let switchDisabled =
      stationFrom && stationFrom.internal_stop_ids && stationTo && stationTo.internal_stop_ids && stationTo.internal_stop_ids.length ? false : true;

    return (
      <form
        className="coach-search-container"
        onSubmit={this.showStations(stationFrom, stationTo)}
      >
        <div style={{ position: 'relative' }}>
          {this.renderLocationFormAutoComplete()}
          {currentFrom && currentFrom.length ? (
            <img
              src={iconClearInput}
              alt="Clear input"
              className="coach-search-clearable"
              onClick={this.clearInput('stationFrom')}
            />
          ) : (
            <img
              src={iconLocation}
              alt="Location"
              className="coach-search-clearable"
              onClick={() => this.fetchLocation(true)}
            />
          )}
          <img
            src={getChangeDirectionIcon(THEME.NAME)}
            alt="Change direction"
            onClick={this.swapDirection}
            className={`coach-search__change-direction coach-search__change-direction--index ${
              switchDisabled ? 'coach-search__change-direction--disabled' : ''
            }`}
          />
        </div>
        <div style={{ position: 'relative' }}>
          {this.renderLocationToAutoComplete(THEME)}
          {currentTo && currentTo.length ? (
            <img
              src={iconClearInput}
              alt="Clear input"
              className="coach-search-clearable"
              onClick={this.clearInput('stationTo')}
            />
          ) : (
            <img
              src={iconLocation}
              alt="Location"
              className="coach-search-clearable"
              onClick={() => this.fetchLocation(false)}
            />
          )}
        </div>
        <button
          className="button button--search"
          disabled={!(stationFrom && stationFrom.internal_stop_ids && stationFrom.internal_stop_ids.length)}
          type="submit"
        >
          {THEME.PAGES.INDEX.BUTTON.SERVICES}
        </button>
      </form>
    );
  };

  renderLocationSearchFormMobile = () => {
    const { stationFrom, stationTo, isShowValidationMsgs } = this.state;
    let currentFrom = stationFrom.name;
    let currentTo = stationTo.name;
    let switchDisabled =
      stationFrom && stationFrom.internal_stop_ids && stationFrom.internal_stop_ids.length && stationTo && stationTo.internal_stop_ids && stationTo.internal_stop_ids.length ? false : true;

    return (
      <form
        className="coach-search-inputs"
        onSubmit={this.showStations(stationFrom, stationTo)}
      >
        <div
          className={`validation ${
            isShowValidationMsgs ? 'validation--msgs' : ''
          }`}
        >
          {this.renderLocationFormAutoComplete()}
          {currentFrom && currentFrom.length ? (
            <img
              src={iconClearInput}
              alt="Clear input"
              className="coach-search-clearable coach-search-clearable--mobile"
              onClick={this.clearInput('stationFrom')}
            />
          ) : (
            <img
              src={iconLocation}
              alt="Location"
              className="coach-search-clearable coach-search-clearable--mobile"
              onClick={() => this.fetchLocation(true)}
            />
          )}

          {this.renderLocationToAutoComplete(THEME)}
          {currentTo && currentTo.length ? (
            <img
              src={iconClearInput}
              alt="Clear input"
              className="coach-search-clearable coach-search-clearable--mobile-from"
              onClick={this.clearInput('stationTo')}
            />
          ) : (
            <img
              src={iconLocation}
              alt="Location"
              className="coach-search-clearable coach-search-clearable--mobile-from"
              onClick={() => this.fetchLocation(false)}
            />
          )}

          <img
            src={getChangeDirectionIcon(THEME.NAME)}
            alt="Change direction"
            onClick={this.swapDirection}
            className={`coach-search__change-direction ${
              switchDisabled ? 'coach-search__change-direction--disabled' : ''
            }`}
          />

          <p className="msgs">
            Sorry, there are no services that match this input. Please confirm
            the details shown on your ticket.
          </p>
        </div>

        <button
          className="button button--search"
          disabled={!(stationFrom && stationFrom.internal_stop_ids && stationFrom.internal_stop_ids.length)}
          type="submit"
        >
          {THEME.PAGES.INDEX.BUTTON.SERVICES}
        </button>
      </form>
    );
  };

  renderServiceNumberForm = (type) => {
    const { stationFromService, isShowValidationMsgs } = this.state;
    const {
      stations,
      clearSearchService,
      isMobile: isMobileProp,
      location,
    } = this.props;

    let currentFrom = stationFromService.route_id;
    let isMobile = !(location.pathname === '/') || isMobileProp;

    return (
      <form
        className={isMobile ? 'coach-search-inputs' : 'coach-search-container'}
        onSubmit={this.showStations(stationFromService, '')}
      >
        <div
          style={{
            position: 'relative',
            width: isMobile ? '100%' : 'calc(72% + 10px)',
            padding: isMobile ? '6px' : 0,
          }}
          className={`validation ${
            isShowValidationMsgs && type === 'mobile' ? 'validation--msgs' : ''
          }`}
        >
          <Autocomplete
            items={!!stations.length && stations[0].route_id && currentFrom && currentFrom.length > 1 && stations[0].route_id ? stations : []}
            getItemValue={(item) => item.route_id}
            renderItem={(item, isHighlighted) => (
              <div
                key={item.route_id}
                className={
                  isHighlighted
                    ? 'autocomplete autocomplete--highlighted'
                    : 'autocomplete'
                }
              >
                {this.highlightEnteredText(item, currentFrom, THEME.NAME)}
              </div>
            )}
            value={stationFromService && stationFromService.route_id}
            onChange={(e) => {
              this.setState({
                stationFromService: {
                  route_id: stationFromService.route_id
                }
              })
              currentFrom = e.target.value;
              this.fetchStations(e.target.value, true, true);
            }}
            onSelect={(name, obj) => {
              obj.type = 'service';
              this.setState({
                stationFromService: obj,
              });
              clearSearchService(true);
            }}
            inputProps={{
              placeholder: `Search by ${
                THEME.NAME === 'NX-Bus' ? 'Bus Number' : 'Service Number'
              }`,
              maxLength: '60',
              onFocus: (e) => {
                currentFrom = e.target.value;
                this.fetchStations(e.target.value, true, true);
              }
            }}
            wrapperStyle={{ position: 'relative' }}
            menuStyle={isMobile ? { ...menuStyle, maxHeight: 200 } : menuStyle}
          />
          {type === 'mobile' && (
            <p className="msgs">
              Sorry, there are no services that match this input. Please confirm
              the details shown on your ticket.
            </p>
          )}
        </div>
        <button
          className="button button--search"
          type="submit"
          disabled={!(stationFromService && stationFromService.type)}
        >
          {THEME.PAGES.INDEX.BUTTON.SERVICES}
        </button>
      </form>
    );
  };

  render() {
    const { userLocation, isMobile, ticket, location } = this.props;
    const {
      locationFrom,
      locationTo,
      isShowValidationMsgs,
      validate,
      emailAddress,
      validateEmail,
      isInfoModalOpen,
      ticketSearch,
      validateTicket,
      clearTicket,
      showAds,
      showTabs,
      showSocials,
      showTicketLookup,
    } = this.state;

    const recentSearches =
      localStorage.getItem('recentSearches') &&
      localStorage.getItem('recentSearches').length &&
      JSON.parse(localStorage.getItem('recentSearches'));

    if (validateTicket !== null) {
      this.setState({ ticketSearch: validateTicket, validateTicket: null });
    }

    if (userLocation.length && locationFrom) {
      this.setState({ stationFrom: { name: userLocation.nearest_stop.name, internal_stop_ids: [userLocation.nearest_stop.internal_id] } });
      this.setState({ locationFrom: false });
    }

    if (userLocation.length && locationTo) {
      this.setState({ stationTo: { name: userLocation.nearest_stop.name, internal_stop_ids: [userLocation.nearest_stop.internal_id] } });
      this.setState({ locationTo: false });
    }

    return (
      <div className="main__search">
        {(!(location.pathname === '/') || isMobile) && (
          <div className="coach-search">
            <h3 className="coach-search-title">{THEME.MAINTITLE ? THEME.MAINTITLE : "Track your Coach"}</h3>
            <div className="coach-search-subtitle">
              {
                getContentText(THEME.NAME, this.state.tabIndex)[
                  'coach-search-subtitle'
                ]
              }
            </div>

            {showTabs ? (
              <div
                className={`coach-search-tabs coach-search-tabs--mobile ${
                  isShowValidationMsgs ? 'coach-search-tabs--validation' : ''
                }`}
              >
                <Tabs
                  selectedIndex={this.state.tabIndex}
                  onSelect={(tabIndex) => this.setState({ tabIndex })}
                >
                  <TabList>
                    <Tab>
                      {this.state.searchTabWidth < 305
                        ? getSearchTabsText(THEME.NAME, 0).short
                        : getSearchTabsText(THEME.NAME, 0).long}
                    </Tab>
                    <Tab>
                      {this.state.searchTabWidth < 305
                        ? getSearchTabsText(THEME.NAME, 1).short
                        : getSearchTabsText(THEME.NAME, 1).long}
                    </Tab>
                  </TabList>

                  <TabPanel>{this.renderLocationSearchFormMobile()}</TabPanel>
                  <TabPanel>{this.renderServiceNumberForm('mobile')}</TabPanel>
                </Tabs>
              </div>
            ) : (
              <Fragment>{this.renderLocationSearchFormMobile()}</Fragment>
            )}
          </div>
        )}

        {location.pathname === '/' && !isMobile && (
          <div className="coach-search-index">
            <h3 className="coach-search-title coach-search-title--index">
              {THEME.MAINTITLE ? THEME.MAINTITLE : "Track your Coach"}
            </h3>
            <div className="coach-search-subtitle coach-search-subtitle--index">
              {
                getContentText(THEME.NAME, this.state.tabIndex)[
                  'coach-search-subtitle'
                ]
              }
            </div>
            <div
              className={`validation ${
                isShowValidationMsgs ? 'validation--msgs' : ''
              }`}
            >
              {showTabs ? (
                <div className="coach-search-tabs">
                  <Tabs
                    selectedIndex={this.state.tabIndex}
                    onSelect={(tabIndex) => this.setState({ tabIndex })}
                  >
                    <TabList>
                      <Tab>
                        {this.state.searchTabWidth < 305
                          ? getSearchTabsText(THEME.NAME, 0).short
                          : getSearchTabsText(THEME.NAME, 0).long}
                      </Tab>
                      <Tab>
                        {this.state.searchTabWidth < 305
                          ? getSearchTabsText(THEME.NAME, 1).short
                          : getSearchTabsText(THEME.NAME, 1).long}
                      </Tab>
                    </TabList>

                    <TabPanel>{this.renderLocationSearchForm()}</TabPanel>
                    <TabPanel>{this.renderServiceNumberForm('index')}</TabPanel>
                  </Tabs>
                </div>
              ) : (
                <Fragment>{this.renderLocationSearchForm()}</Fragment>
              )}

              <div className="msgs msgs--index">
                <p>
                  Sorry, there are no services that match this input. Please
                  confirm the details shown on your ticket.
                </p>
              </div>
            </div>
          </div>
        )}

        <div className="ticket-container">
          {/* <div className="recent-box"> */}
          {recentSearches && recentSearches.length > 1 && (
            <div className="recent-searches">
              <h3>Recent Searches</h3>
              {recentSearches.map((search, index) =>
                index >= 1 ? (
                  <RecentSearch
                    key={v4()}
                    search={search}
                    recentSearch={this.recentSearch}
                  />
                ) : null
              )}
            </div>
          )}

          {/* {THEME.NAME === 'Megabus' && <SocialLinks />} */}
          {/* </div> */}
          {showTicketLookup && (
            <div className="ticket-form">
              <h3>Ticket Lookup</h3>

              <Form
                onSubmit={(submittedValues) =>
                  this.handleTicketForm(THEME.NAME, { submittedValues })
                }
                values={{
                  ticketNumber:
                    !clearTicket ||
                    (!isEmptyObj(ticket) &&
                      ticket.ticket_legs &&
                      ticket.ticket_legs.length)
                      ? ticketSearch
                      : '',
                  emailAddress: emailAddress,
                }}
              >
                {(formApi) => (
                  <form onSubmit={formApi.submitForm}>
                    <div className="ticket-number">
                      <Text
                        field="ticketNumber"
                        placeholder="Ticket Number"
                        maxLength="20"
                        validate={this.validate}
                        onChange={(e) => {
                          this.setState({
                            clearTicket: false,
                            ticketSearch: e,
                          });
                          this.validateTicket(e);
                        }}
                      />
                      <Text
                        field="emailAddress"
                        placeholder="Email Address"
                        maxLength="72"
                        validate={this.validateEmail}
                        onChange={(e) => {
                          this.setState({ emailAddress: e });
                        }}
                      />
                      {ticketSearch && ticketSearch.length >= 2 && (
                        <img
                          src={iconClearInput}
                          alt="Clear input"
                          className="coach-search-clearable coach-search-clearable--ticket"
                          onClick={this.clearInput('ticketNumber')}
                        />
                      )}

                      {emailAddress && emailAddress.length >= 2 && (
                        <img
                          src={iconClearInput}
                          alt="Clear input"
                          className="coach-search-clearable coach-search-clearable--email"
                          onClick={this.clearInput('emailAddress')}
                        />
                      )}

                      <img
                        src={getHelpIcon(THEME.NAME)}
                        onClick={this.toggleInfoModal}
                        style={{ zIndex: 0 }}
                        alt="help e-mail"
                      />
                    </div>
                    <button
                      type="submit"
                      className="button button--ticket"
                      disabled={!validate || !validateEmail}
                    >
                      Search Ticket
                    </button>
                  </form>
                )}
              </Form>
            </div>
          )}

          {showAds && (
            <div className="ads">
              <a
                href="https://banners.wlservices.fr/jump-676"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={adsHolder} alt="Ad" />
              </a>
              <div className="ads-footer">
                <div className="button-div">
                  <button
                    type="submit"
                    className="button button--ad"
                    onClick={this.closeAd}
                  >
                    Close Ad
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>

        {showSocials && THEME.NAME === 'Megabus' && (
          <div className="social-container">
            <div className="social-block">
              <div className="social-block__descrption">
                <span>For all enquiries, email us:</span>
                <a href={"mailto:" + (THEME.LOCALE === "US" ? "inquiries" : "enquiries") + "@megabus.com?subject=RE:%20CoachTracker&body=%0D%0AURL: " + window.location.href + "%0D%0A%0D%0AUser Agent Info: " + navigator.userAgent}>{(THEME.LOCALE === "US" ? "inquiries" : "enquiries") + "@megabus.com"}</a>
              </div>
              <div className="social-block__links">
                <a
                  href={THEME.LOCALE === 'US' ? "https://twitter.com/megabus" : "https://twitter.com/megabusuk"}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={iconTwitterMegabus} alt="twitter" />
                </a>
                <a
                  href={THEME.LOCALE === 'US' ? "https://www.facebook.com/megabus.com.officialpage" : "https://www.facebook.com/megabusUK"}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={iconFacebookMegabus} alt="facebook" />
                </a>
                <a
                  href={THEME.LOCALE === 'US' ? "https://www.instagram.com/megabus" : "https://www.instagram.com/megabusuk/"}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={iconInstagramMegabus} alt="instagram" />
                </a>
              </div>
            </div>
          </div>
        )}

        {showSocials && THEME.NAME === 'Citylink' && (
          <div className="social-container">
            <div className="social-block">
              <div className="social-block__descrption">
                <span>For all enquiries, email us:</span>
                <a href={"mailto:info@citylink.co.uk"}>info@citylink.co.uk</a>
              </div>
              <div className="social-block__links">
                <a
                  href="https://twitter.com/scotcitylink"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={iconTwitterCitylink} alt="twitter" />
                </a>
                <a
                  href="https://www.facebook.com/citylink.co.uk"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={iconFacebookCitylink} alt="facebook" />
                </a>
                <a
                  href="https://www.instagram.com/scottish_citylink/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={iconInstagramCitylink} alt="facebook" />
                </a>
              </div>
            </div>
          </div>
        )}

        <Modal
          shouldCloseOnOverlayClick={true}
          isOpen={isInfoModalOpen}
          onRequestClose={this.closeModal}
          style={stylesModal}
          className="ReactModal__Content--ticket"
        >
          <div className="modal">
            <div className="modal-center">
              <h3 className="modal__title">Ticket Lookup Help</h3>
              <p>Where to find the ticket number on your email confirmation</p>
              <img
                className="modal__close-ticket"
                src={getCloseIcon(THEME.NAME)}
                onClick={this.closeModal}
                alt="Icon Close"
              />
            </div>
          </div>
          <div className="img-email-form"></div>
        </Modal>
      </div>
    );
  }
}

export default withRouter(
  connect(mapStateToProps, {
    fetchSearchService,
    fetchSearchLocation,
    fetchServices,
    clearSearchService,
    saveSearchField,
    fetchTicketInfo,
    clearTicketInfo,
  })(SearchService)
);



// WEBPACK FOOTER //
// ./src/containers/SearchService.js